module.exports = __webpack_public_path__ + "static/media/closeEnvelope.e7d09b5e.svg";